module.exports = __webpack_public_path__ + "img/6.41e25d22.jpg";